import React from 'react';
import ReactModal from 'react-modal';
import { IPageBuilderFormPreviewProps } from './IPageBuilderFormPreviewProps';
import styled from 'styled-components';
import styles from './PageBuilderFormPreview.module.scss';
import { isValidHexColor } from '../PageBuilderSideBar/BlockSettings/domain';
import { ReactComponent as XIcon } from 'containers/channels/collections/deleteConfirmation/icons/x.svg';
import BlockTextContainer, { BlockSubTextContainer } from '../PageBuilderBuildingPreview/BlockComponents/BlockTextContainer';
import anchorme from 'anchorme';
import { ButtonAction, defaultCalendlyTimeSlots, FormFieldTypes } from 'containers/PageBuilder/SinglePageContainer/domain';
import BlockButton from '../PageBuilderBuildingPreview/BlockComponents/BlockButton';
import PageBuilderService from 'api/services/page-builder';
import miscUtils from 'utils/miscUtils';
import 'react-phone-number-input/style.css';
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input';
import useUAIP from 'hooks/useUAIP';
import Cookie from 'js-cookie';
import InnerHTML from 'dangerously-set-html-content';
import AppSelect from 'elements/appSelect';
import CalendlyEventTypeTimesSelector from '../PageBuilderSideBar/PageBuilderWidgets/FormsContainer/PageFormSettings/PageFormFieldSettings/CalendlyEventTypeTimesSelector';
import { formatDateToLocal } from 'api/services/page-builder/domain';
import ResizeObserver from 'resize-observer-polyfill';
import useGeoInfo from 'hooks/useGeoInfo';
// import { SinglePageContainerContext } from 'containers/PageBuilder/SinglePageContainer/SinglePageContainer';


const ContentContainer: any = styled.div<{design: any, showCalendlySchedule: boolean}>`
    width: 100%;
    border-radius: .5rem;
    position: relative;
    padding-left: ${(props: any) => 
      props.showCalendlySchedule ?
      `0px` :
      `30px`
    };
    padding-right: ${(props: any) => 
      props.showCalendlySchedule ?
      `0px` :
      `30px`
    };
    padding-top: ${(props: any) => 
      props.design.container_padding_top ?
      `${props.design.container_padding_top}px` :
      `0px`
    };
    padding-bottom: ${(props: any) => 
      props.showCalendlySchedule ? 
      `0px` :
      props.design.container_padding_bottom ?
      `${props.design.container_padding_bottom}px` :
      `0px`
    };
    background-color: ${(props: any) => 
      props.design.container_background_color &&
      isValidHexColor(props.design.container_background_color) ?
      props.design.container_background_color :
      'transparent'
    };
`;

const EmbedContentContainer: any = styled.div`
  margin-top: 10px;
  width: 100%;
  height: fit-content;
  border-radius: 0 0 .5rem .5rem;
  overflow: hidden;

  .calendly-inline-widget {
    min-width: 320px;
    height: calc(100vh - 300px);
    overflow: hidden;
    max-height: 600px;
  }
`;

const IconContainer: any = styled.span<{design: any}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;

  svg {
    path {
      stroke: ${(props: any) => 
        props.design.close_icon_color &&
        isValidHexColor(props.design.close_icon_color) ?
        props.design.close_icon_color :
        '#333333'
      };
  }
`;

const ContentWrapper: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FieldsContainer: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 25px;
`;

const FormGroupContainer: any = styled.div<{index: number}>`
  width: 100%;
  margin-top: ${(props: any) => 
    props.index ? 
    `10px` :
    `0px`
  };
`;

const FormGroupLabelContainer: any = styled.div`
  width: 100%;
`;

const FormGroupLabelText: any = styled.p<{design: any, pageStyles: any}>`
  margin: 0;
  padding: 0;
  font-weight: 400;

  font-size: ${(props: any) =>
    props.design.field_input_label_font_size &&
    props.design.field_input_label_font_size <= 50 ?
    `${props.design.field_input_label_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_label_line_height &&
    props.design.field_input_label_line_height <= 50 ?
      `${props.design.field_input_label_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_label_font_family ?
      `${props.design.field_input_label_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_label_color &&
    isValidHexColor(props.design.field_input_label_color) ?
    props.design.field_input_label_color :
    '#000000'
  };
`;

const FormGroupLabelTextRequired: any = styled.span<{design: any}>`
  margin: 0;
  padding: 0;
  font-weight: 400;

  font-size: ${(props: any) =>
    props.design.field_input_label_font_size &&
    props.design.field_input_label_font_size <= 50 ?
    `${props.design.field_input_label_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_label_line_height &&
    props.design.field_input_label_line_height <= 50 ?
      `${props.design.field_input_label_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_label_font_family ?
      `${props.design.field_input_label_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    props.design.field_input_required_color :
    '#FF0000'
  };
`;

const FormGroupErrorText: any = styled(FormGroupLabelText)`
  margin-top: 5px;
  color: ${(props: any) =>
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    props.design.field_input_required_color :
    '#FF0000'
  };
`;

const FormGroupInputContainer: any = styled.div<{design: any, isError: boolean, fieldType: FormFieldTypes}>`
  width: 100%;
  border: ${(props: any) => 
    // props.fieldType === FormFieldTypes.Calendly ?
    // 'none' :
    props.isError &&
    props.design.field_input_required_color &&
    isValidHexColor(props.design.field_input_required_color) ?
    `1px solid ${props.design.field_input_required_color}` :
    props.design.field_input_border_color &&
    isValidHexColor(props.design.field_input_border_color) ?
    `1px solid ${props.design.field_input_border_color}` :
    `1px solid #D5D8DF` 
  };
  border-radius: .5rem;
  margin-top: 5px;
  overflow: hidden;
`;

export const FormGroupInputElement: any = styled.input<{design: any}>`
  font-size: ${(props: any) =>
    props.design.field_input_font_size &&
    props.design.field_input_font_size <= 50 ?
    `${props.design.field_input_font_size}px` :
    `20px`
  };
  line-height: ${(props: any) =>
    props.design.field_input_line_height &&
    props.design.field_input_line_height <= 50 ?
      `${props.design.field_input_line_height}px` :
      `25px`
  };
  font-family: ${(props: any) =>
    props.design.field_input_font_family ?
      `${props.design.field_input_font_family} !important` :
      `-apple-system, Arial !important`
  };
  color: ${(props: any) =>
    props.design.field_input_color &&
    isValidHexColor(props.design.field_input_color) ?
    props.design.field_input_color :
    '#000000'
  };
  width: 100%;
  height: ${(props: any) =>
    props.design.field_input_height &&
    props.design.field_input_height > 5 &&
    props.design.field_input_height < 100 ?
    `${props.design.field_input_height}px` :
    `44px`
  };
  border: none;
  padding: 0 10px;
  background-color: ${(props: any) =>
    props.design.field_input_background_color &&
    isValidHexColor(props.design.field_input_background_color) ?
    props.design.field_input_background_color :
    '#FFFFFF'
  };

  &:focus {
    outline: none;
  }

  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::-moz-placeholder { /* Firefox 19+ */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &:-ms-input-placeholder { /* IE 10+ */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::-ms-input-placeholder { /* Microsoft Edge */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }
  &::placeholder { /* Standard */
    color: ${(props: any) =>
      props.design.field_input_placeholder_color &&
      isValidHexColor(props.design.field_input_placeholder_color) ?
      props.design.field_input_placeholder_color :
      '#D1D1D1'
    };
  }

  &.no-caret {
    caret-color: transparent;
  }
`;

const FormGroupPhoneInputElement: any = styled(PhoneInput)<{design: any}>`
  padding-left: 10px;
  input[type="tel"] {
    font-size: ${(props: any) =>
      props.design.field_input_font_size &&
      props.design.field_input_font_size <= 50 ?
      `${props.design.field_input_font_size}px` :
      `20px`
    };
    line-height: ${(props: any) =>
      props.design.field_input_line_height &&
      props.design.field_input_line_height <= 50 ?
        `${props.design.field_input_line_height}px` :
        `25px`
    };
    font-family: ${(props: any) =>
      props.design.field_input_font_family ?
        `${props.design.field_input_font_family} !important` :
        `-apple-system, Arial !important`
    };
    color: ${(props: any) =>
      props.design.field_input_color &&
      isValidHexColor(props.design.field_input_color) ?
      props.design.field_input_color :
      '#000000'
    };
    width: 100%;
    height: ${(props: any) =>
      props.design.field_input_height &&
      props.design.field_input_height > 5 &&
      props.design.field_input_height < 100 ?
      `${props.design.field_input_height}px` :
      `44px`
    };
    border: none;
    padding: 0 10px;
    background-color: ${(props: any) =>
      props.design.field_input_background_color &&
      isValidHexColor(props.design.field_input_background_color) ?
      props.design.field_input_background_color :
      '#FFFFFF'
    };

    &:focus {
      outline: none;
    }
  
    &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::-moz-placeholder { /* Firefox 19+ */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &:-ms-input-placeholder { /* IE 10+ */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::-ms-input-placeholder { /* Microsoft Edge */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
    &::placeholder { /* Standard */
      color: ${(props: any) =>
        props.design.field_input_placeholder_color &&
        isValidHexColor(props.design.field_input_placeholder_color) ?
        props.design.field_input_placeholder_color :
        '#D1D1D1'
      };
    }
  }
`;

const FormButton: any = styled(BlockButton)<{isSubmitting: boolean}>`
  width: 100%;
  max-width: 100%;
  margin-top: 25px;
  opacity: ${(props: any) => 
    props.isSubmitting ?
    `.5` :
    `1`
  };
`;

const FormConsentContainer: any = styled.div`
  margin-top: 25px;
  width: 100%;
`

const FormConsentWrapper: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const FormConsentInput: any = styled.input<{design: any}>`
  width: 18px;
  height: 18px;
  border: ${(props: any) => 
    props.design.field_input_border_color &&
    isValidHexColor(props.design.field_input_border_color) ?
    `1px solid ${props.design.field_input_border_color}` :
    `1px solid #D5D8DF`
  };
`;

const FormConsentLabelTextContainer: any = styled(BlockTextContainer)`
  margin-left: 5px;
`;

const SubmittedTextContainer: any = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const isCalendlyScheduledEvent = (e: any) => {
  return e.data.event &&
         e.data.event.indexOf('calendly') === 0 &&
         e.data.event === 'calendly.event_scheduled'
}

const PageBuilderFormPreview: React.FC<IPageBuilderFormPreviewProps> = (props) => {

    // const singlePageContainerContext = React.useContext(SinglePageContainerContext);
    const hideCalendlyEventTimeDropdownRef = React.useRef<any>(null);
    const showingCalendlyScheduleRef = React.useRef<boolean>(false);

    const [showCalendlySchedule, setShowCalendlySchedule] = React.useState<boolean>(false);
    const [selectedEventTime, setSelectedEventTime] = React.useState<any>(null);
    const [formData, setFormData] = React.useState({
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      consent: false,
      discrete: "",
    });

    const [formDataError, setFormDataError] = React.useState<any>({
      first_name: false,
      last_name: false,
      email: false,
      phone_number: false,
      consent: false,
    });

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const {
      ua,
      ip
    } = useUAIP();

    const [fieldsContainerWidth, setFieldsContainerWidth] = React.useState<number>(0);

    const geoInfo = useGeoInfo();

    React.useEffect(() => {
      const handleCalendlyEvent = (e: MessageEvent) => {
        if (isCalendlyScheduledEvent(e)) {

          const sourceIframe: any = document.querySelector(`#${CSS.escape(props.pageForm.render_id)} iframe`);

          if(
            sourceIframe &&
            sourceIframe.contentWindow &&
            sourceIframe.contentWindow === e.source
          ) {
            showingCalendlyScheduleRef.current = false;

            setTimeout(() => {
              onSubmitted();
            }, 2000);
          }
        }
      };
    
      window.addEventListener('message', handleCalendlyEvent);
    
      return () => {
        window.removeEventListener('message', handleCalendlyEvent);
      };
    }, []);

    React.useEffect(() => {
      if(props.pageFormsOpenState[props.pageForm.render_id]) {
        setTimeout(() => {
          const fieldsContainerElement: HTMLElement = document.getElementById(`page-builder-form-preview-fields-container-${props.pageForm.render_id}`) as HTMLElement;

          if (fieldsContainerElement) {
            // Create a ResizeObserver to watch for changes in the div's size
            const resizeObserver = new ResizeObserver(() => {
              setFieldsContainerWidth(fieldsContainerElement.offsetWidth); // Update the state with the new width
            });
            
            // Start observing the div's size
            resizeObserver.observe(fieldsContainerElement);
      
            // Set the initial width
            setFieldsContainerWidth(fieldsContainerElement.offsetWidth);
      
            // Clean up the observer when the component unmounts
            return () => {
              resizeObserver.unobserve(fieldsContainerElement);
            };
          }
        }, 500);
      }
    }, [props.pageFormsOpenState[props.pageForm.render_id]]);

    React.useEffect(() => {
      if(selectedEventTime) {
        setSelectedEventTime(null);
      }
    }, [props.pageForm.fields]);

    const closeForm = () => {
        let pageFormsOpenStateCopy = JSON.parse(JSON.stringify(props.pageFormsOpenState));

        if(
            pageFormsOpenStateCopy &&
            pageFormsOpenStateCopy[props.pageForm.render_id]
        ) {
            pageFormsOpenStateCopy[props.pageForm.render_id] = false;

            props.setPageFormsOpenState(pageFormsOpenStateCopy);
        }
    }

    const getInputType = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
        case FormFieldTypes.LastName:
          return "text";
        case FormFieldTypes.Email:
          return "email"
        case FormFieldTypes.PhoneNumber:
          return "tel"
      }
    }

    const hasField = (fieldType: FormFieldTypes) => {
      let isField: boolean = false;

      props.pageForm.fields.forEach((field: any) => {
        if(field.type === fieldType) {
          isField = true;
        }
      });

      return isField;
    }

    const getUserConsentField = () => {
      let userConsentField: any;

      props.pageForm.fields.forEach((field: any) => {
        if(field.type === FormFieldTypes.UserConsent) {
          userConsentField = field;
        }
      });

      return userConsentField;
    }

    const getInputName: any = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
          return "first_name";
        case FormFieldTypes.LastName:
          return "last_name";
        case FormFieldTypes.Email:
          return "email"
        case FormFieldTypes.PhoneNumber:
          return "phone_number"
      }
    }

    const getInputValue = (fieldType: FormFieldTypes) => {
      switch(fieldType) {
        case FormFieldTypes.FirstName:
          return formData.first_name;
        case FormFieldTypes.LastName:
          return formData.last_name;
        case FormFieldTypes.Email:
          return formData.email;
        case FormFieldTypes.PhoneNumber:
          return formData.phone_number;
        default:
          return '';
      }
    }

    const onChangeFormField = (e: any) => {
      if(formDataError[e.target.name]) {
        setFormDataError({
          ...formDataError,
          [e.target.name]: false,
        });
      }

      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    const fieldIsRequired = (fieldType: FormFieldTypes) => {
      let isFieldRequired: boolean = false;

      props.pageForm.fields.forEach((field: any) => {
        if(
          field.type === fieldType &&
          field.is_required
        ) {
          isFieldRequired = true;
        }
      });

      return isFieldRequired;
    }

    const validate = () => {
      let valid = true;

      if(formData.discrete) {
        valid = false;
      }
      
      const formDataErrorCopy = JSON.parse(JSON.stringify(formDataError));

      if(
        hasField(FormFieldTypes.FirstName) &&
        formData.first_name.trim() === "" &&
        fieldIsRequired(FormFieldTypes.FirstName)
      ) {
        formDataErrorCopy.first_name = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.LastName) &&
        formData.last_name.trim() === "" &&
        fieldIsRequired(FormFieldTypes.LastName)
      ) {
        formDataErrorCopy.last_name = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.Email) &&
        formData.email.trim() === "" &&
        fieldIsRequired(FormFieldTypes.Email)
      ) {
        formDataErrorCopy.email = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.Email) &&
        formData.email.trim() &&
        !miscUtils.validateEmail(formData.email.trim())
      ) {
        formDataErrorCopy.email = true;
        valid = false;
      }

      if(
        hasField(FormFieldTypes.PhoneNumber) &&
        !isPossiblePhoneNumber(formData.phone_number) &&
        fieldIsRequired(FormFieldTypes.PhoneNumber)
      ) {
        formDataErrorCopy.phone_number = true;   
        valid = false;
      }

      if(
        hasField(FormFieldTypes.UserConsent) &&
        !formData.consent &&
        fieldIsRequired(FormFieldTypes.UserConsent)
      ) {
        formDataErrorCopy.consent = true;        
        valid = false;
      }

      if(!valid) {
        setFormDataError(formDataErrorCopy);
      }

      return valid;
    }

    const onSubmitted = () => {
      if(
        props.pageForm.button_action === ButtonAction.URL
      ) {
        window.open(props.pageForm.button_url, '_self');
      }
    }

    const onSubmittedCleanup = () => {
      setIsSubmitting(false);
      if(
        props.pageForm.button_action !== ButtonAction.URL
      ) {
        setSubmitted(true);
      }
      if(props.pageForm.button_action !== ButtonAction.None) {
        closeForm();
      }
    }

    const requestFormSubmission = () => {
      setIsSubmitting(true);

      const payload: any = {
        ...formData,
      }

      const _fbc = Cookie.get('_fbc');

      if(_fbc) {
        payload.fbc = _fbc;
      }

      payload.ua = ua;
      payload.ip = ip;

      PageBuilderService.getInstance()
      .submitFormLead(
        props.pageForm.group_id,
        'widgets',
        props.pageForm.widget_id,
        {
          data: payload,
        },
      )
      .then(() => {
        Cookie.remove('_fbc', { path: "/", domain: window.location.hostname });
        if(hasField(FormFieldTypes.Calendly)) {
          showingCalendlyScheduleRef.current = true;
          setShowCalendlySchedule(true);
          setIsSubmitting(false);
          return;
        }
        onSubmitted();
      })
      .catch((error: any) => {
        console.error(error)
        new Error(error)
      })
      .finally(() => {
        if(!showingCalendlyScheduleRef.current) {
          onSubmittedCleanup();
        }
      });
    }


    const submitForm = () => {
      if(props.preview) {
        return;
      }

      if(!validate()) {
        return;
      }

      requestFormSubmission();
    }

    const getErrorMessage = (field: any) => {
      if(
        field.type === FormFieldTypes.PhoneNumber
      ) {
        return `Please enter a valid phone number`
      }

      if(
        field.type === FormFieldTypes.Email &&
        formData.email.trim()
      ) {
        return `Please enter a valid email address`
      }

      return field.error_message ? 
        field.error_message :
        `${field.label} is required`
    }

    const getEmbedHtml = (url: string) => {
        return `
          <!-- Calendly inline widget begin -->
          <div id="${props.pageForm.render_id}" class="calendly-inline-widget" data-url="${url}?hide_event_type_details=1&hide_gdpr_banner=1&name=${encodeURIComponent(`${formData.first_name} ${formData.last_name}`)}&email=${encodeURIComponent(`${formData.email}`)}"></div>
          <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async onload="handleCalendlyLoaded()"></script>
          <!-- Calendly inline widget end -->  `
    }

    const getInlineInputStyles = () => {   
      return {
        fontSize: 
          props.pageForm.design.field_input_font_size &&
          props.pageForm.design.field_input_font_size <= 50 ?
          `${props.pageForm.design.field_input_font_size}px` :
          `20px`,
        lineHeight:
          props.pageForm.design.field_input_line_height &&
          props.pageForm.design.field_input_line_height <= 50 ?
          `${props.pageForm.design.field_input_line_height}px` :
          `25px`,
        fontFamily:
          props.pageForm.design.field_input_font_family ?
          `${props.pageForm.design.field_input_font_family}` :
          `-apple-system, Arial`,
        color: 
          props.pageForm.design.field_input_color &&
          isValidHexColor(props.pageForm.design.field_input_color) ?
          props.pageForm.design.field_input_color :
          '#000000',
      }
    }

    const getFieldInput = (field: any) => {
      if(field.type === FormFieldTypes.Calendly) {
        return (
          <>
            <AppSelect
            hideDropdownRef={hideCalendlyEventTimeDropdownRef}
            value={selectedEventTime ? `${formatDateToLocal(selectedEventTime.start_time)}${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) ? ` (${miscUtils.getUserTimezoneAbbreviation()} ${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})` : ''}` : ''}
            noCaret
            cursorPointer
            useTippy
            tippyPlacement="bottom-start"
            tippyContainerClassName={`${styles.dropdown_popup_container}${props.buildingPreview ? ' building-preview' : ''}`}
            popupStyles={{
              width: `${fieldsContainerWidth}px`,
              overflow: 'hidden',
              backgroundColor: 
                props.pageForm.design.dropdown_background_color &&
                isValidHexColor(props.pageForm.design.dropdown_background_color) ?
                props.pageForm.design.dropdown_background_color :
                '#FFFFFF',
              borderColor: 
                props.pageForm.design.dropdown_border_color &&
                isValidHexColor(props.pageForm.design.dropdown_border_color) ?
                props.pageForm.design.dropdown_border_color :
                '#D5D8DF',
              borderRadius:
                props.pageForm.design.dropdown_border_radius &&
                props.pageForm.design.dropdown_border_radius <= 30 ?
                `${props.pageForm.design.dropdown_border_radius}px`:
                `4px`,
            }}
            pageBuilderView
            pageBuilderViewDesign={props.pageForm.design}
            inputClassName={styles.dropdown_input}
            placeholder={field.placeholder ? field.placeholder : 'Select time'}
            inputIconClassName={styles.dropdown_input_icon}
            >
                <CalendlyEventTypeTimesSelector
                group={props.group}
                eventTypeUri={field.eventType ? field.eventType.uri : ''}
                selectItem={(eventTime: any) => {
                    setSelectedEventTime(eventTime);
                }}
                elementContainerClass={styles.dropdown_option_container}
                slots={field.slots ? field.slots : defaultCalendlyTimeSlots}
                labelStyles={getInlineInputStyles()}
                />
            </AppSelect>
          </>
        )
      }

      if(field.type === FormFieldTypes.PhoneNumber) {
        return (
          <FormGroupPhoneInputElement
          international
          countryCallingCodeEditable={false}
          design={props.pageForm.design}
          placeholder={field.placeholder}
          defaultCountry={geoInfo ? geoInfo.country_code : 'US'}
          value={getInputValue(field.type)}
          onChange={(value: any) => {
            if(value) {
              if(formDataError.phone_number) {
                setFormDataError({
                  ...formDataError,
                  phone_number: false,
                });
              }
        
              setFormData({
                ...formData,
                phone_number: value,
              });
            }
          }}
          />
        )
      }
      return (
        <FormGroupInputElement
        design={props.pageForm.design}
        type={getInputType(field.type)}
        placeholder={field.placeholder}
        name={getInputName(field.type)}
        value={getInputValue(field.type)}
        onChange={onChangeFormField}
        />
      )
    }

    const getPopupContent = () => {
      if(showCalendlySchedule) {
        return (
            <EmbedContentContainer
            >
              <InnerHTML
              html={getEmbedHtml(selectedEventTime ? selectedEventTime.scheduling_url : '')}
              />
            </EmbedContentContainer>
        )
      }

      return (
        <>
          {submitted ? (
            <SubmittedTextContainer
            >
              <BlockTextContainer
              design={props.pageForm.design}
              pageStyles={props.pageStyles}
              textKey="submission_message"
              fallbackTextColor="#333333"
              dangerouslySetInnerHTML={{
                  __html: anchorme(
                    props.pageForm.submission_message &&
                    miscUtils.stripHTML(props.pageForm.submission_message).length ?
                    props.pageForm.submission_message : 
                    `<p>Thank you for your submission!</p>`
                  ),
              }}
              />
            </SubmittedTextContainer>
          ) : (
            <ContentWrapper
            >
              <BlockTextContainer
              design={props.pageForm.design}
              pageStyles={props.pageStyles}
              textKey="heading"
              fallbackTextColor="#FFFFFF"
              dangerouslySetInnerHTML={{
                  __html: anchorme(props.pageForm.heading),
              }}
              />
  
  
              <BlockSubTextContainer
              design={props.pageForm.design}
              pageStyles={props.pageStyles}
              textKey="subtext"
              fallbackTextColor="#FFFFFF"
              dangerouslySetInnerHTML={{
                  __html: anchorme(props.pageForm.subtext),
              }}
              />
  
              <FieldsContainer
              id={`page-builder-form-preview-fields-container-${props.pageForm.render_id}`}
              >
                {props.pageForm.fields.map((field: any, index: number) => {
                  if(field.type === FormFieldTypes.UserConsent) {
                    return <></>
                  }
  
                  return (
                    <FormGroupContainer
                    index={index}
                    >
                      <FormGroupLabelContainer
                      >
                        <FormGroupLabelText
                        design={props.pageForm.design}
                        >
                          {field.label}
                          {field.is_required ? (
                            <FormGroupLabelTextRequired
                            design={props.pageForm.design}
                            >
                              *
                            </FormGroupLabelTextRequired>
                          ) : <></>}
                        </FormGroupLabelText>
                      </FormGroupLabelContainer>
                      <FormGroupInputContainer
                      design={props.pageForm.design}
                      isError={formDataError[getInputName(field.type)]}
                      fieldType={field.type}
                      >
                        {getFieldInput(field)}
                      </FormGroupInputContainer>
                      {formDataError[getInputName(field.type)] ? 
                        <FormGroupErrorText
                        design={props.pageForm.design}
                        >
                          <FormGroupLabelTextRequired
                          design={props.pageForm.design}
                          >
                            *
                          </FormGroupLabelTextRequired>
                          {
                            getErrorMessage(field)
                          }
                        </FormGroupErrorText> 
                        : 
                        <></>
                      }
                    </FormGroupContainer>
                  )
                })}
                <div
                className={styles.discrete}
                >
                  <input
                  type="text"
                  name="discrete"
                  value={formData.discrete}
                  onChange={onChangeFormField}
                  />
                </div>
              </FieldsContainer>
  
              <FormButton
              design={props.pageForm.design}
              isSubmitting={isSubmitting}
              pageStyles={props.pageStyles}
              onClick={() => submitForm()}
              disabled={isSubmitting}
              >
                {isSubmitting ? `Saving...` : props.pageForm.button_text}
              </FormButton>
  
              {hasField(FormFieldTypes.UserConsent) ? (
                <FormConsentContainer
                >
                  <FormConsentWrapper
                  >
                    <FormConsentInput
                    design={props.pageForm.design}
                    type="checkbox"
                    checked={formData.consent}
                    onClick={() => {
                      if(formDataError.consent) {
                        setFormDataError({
                          ...formDataError,
                          consent: false,
                        });
                      }
                      setFormData({
                        ...formData,
                        consent: !formData.consent,
                      })
                    }}
                    />
                    <FormConsentLabelTextContainer
                    design={{
                      ...props.pageForm.design,
                      text_alignment: 'left',
                    }}
                    pageStyles={props.pageStyles}
                    textKey="user_consent"
                    fallbackTextColor="#333333"
                    dangerouslySetInnerHTML={{
                        __html: anchorme(getUserConsentField().label),
                    }}
                    />
                  </FormConsentWrapper>
                  {formDataError.consent ? 
                    <FormGroupErrorText
                    design={props.pageForm.design}
                    >
                      <FormGroupLabelTextRequired
                      design={props.pageForm.design}
                      >
                        *
                      </FormGroupLabelTextRequired>
                      {
                        getUserConsentField().error_message ? 
                        getUserConsentField().error_message :
                        `Please check the box to continue`
                      }
                    </FormGroupErrorText> 
                    : 
                    <></>
                  }
                </FormConsentContainer>
              ) : <></>}
            </ContentWrapper>
          )}
        </>
      )
    }
    
  return (
    <ReactModal
    isOpen={props.pageFormsOpenState[props.pageForm.render_id]}
    style={{
        content: {
          width: `${props.pageForm.design.container_width}px`,
          maxWidth: props.parentSelectorId ? `100%` : `100vw`,
          maxHeight: showCalendlySchedule ? undefined : `calc(100vh - 100px)`,
          overflow: showCalendlySchedule ? 'hidden' : 'auto',
          borderRadius: ".5rem",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          position: props.parentSelectorId ? 'absolute' : 'fixed',
          border: 0,
          padding: 0,
        },
        overlay: {
          position: props.parentSelectorId ? 'absolute' : 'fixed',
          backgroundColor: `rgba(0, 0, 0, .5)`,
          zIndex: 99999,
        }
    }}
    parentSelector={
      props.parentSelectorId ? 
      () => document.getElementById(props.parentSelectorId as string) as HTMLElement :
      undefined
    }
    portalClassName={styles.modal_portal}
    >
        <ContentContainer
        design={props.pageForm.design}
        showCalendlySchedule={showCalendlySchedule}
        >
          <IconContainer
          design={props.pageForm.design}
          onClick={closeForm}
          >
            <XIcon
            />
          </IconContainer>
            <>
              {getPopupContent()}
            </>
        </ContentContainer>
    </ReactModal>
  )
}

export default PageBuilderFormPreview;